var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaprxMarkWhite = function SvgCaprxMarkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-labelledby": "caprx-mark-white",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    fillRule: "evenodd",
    d: "m19.253 0-4.835 5.714 4.835 5.803L24 5.714z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    fillRule: "evenodd",
    d: "m19.253 11.516-4.835 5.715 4.835 5.802L24 17.231z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    fillRule: "evenodd",
    d: "M9.582 0 4.835 5.714 0 11.516l4.835 5.714 4.747 5.803h9.671l-4.836-5.803-4.835-5.714 4.835-5.802L19.253 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCaprxMarkWhite;